import { useEffect } from "react";

const SITE = "Hamza Mehboob";
const ORIGIN = "https://www.hamzamehboob.me";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

/**
 * Per-route <title>, description, canonical and social tags.
 * The defaults live in public/index.html; this only updates them on navigation.
 */
export default function usePageMeta({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : document.title;
    const url = `${ORIGIN}${path}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description, path]);
}
